import {Modal, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import * as css from './LifestyleScoreInfoModal.css';

const listItems = [
  'Very healthy (100–86)',
  'Healthy (85–70)',
  'Moderately healthy (69–51)',
  'Less healthy (50–0)',
];

export const LifestyleScoreInfoModal = () => (
  <Modal
    header={
      <Text className={sprinkles({flex: 'flex', items: 'center', size: 'full'})} variant="heading4">
        Lifestyle Score explained
      </Text>
    }
    layout="drawer">
    <div className={sprinkles({flex: 'flex', dir: 'col', gap: 16})}>
      <Text as="p">
        Non-genetic factors like lifestyle and environment account for at least 90% of longevity.
      </Text>

      <Text as="p">
        The higher your Lifestyle Score is out of 100, the more likely it is that your TallyAge™
        will be lower. Lifestyle Scores are divided into 4 ranges:
      </Text>
      <Text as="ul" color="peach">
        {listItems.map((listItem, i) => (
          <li className={css.listItem} key={i}>
            <Text>{listItem}</Text>
          </li>
        ))}
      </Text>
    </div>
  </Modal>
);
